import React from 'react';
import { X, User, Building2, CreditCard } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import BusinessSwitcher from '../business/BusinessSwitcher';

const SideMenu = ({ menuOpen, setMenuOpen }) => {
  const navigate = useNavigate();
  const { signOut } = useAuth();

  const handleNavigation = (route) => {
    navigate(route);
    setMenuOpen(false);
  };

  const handleLogout = async () => {
    await signOut();
    setMenuOpen(false);
    navigate('/login');
  };

  return (
    <>
      {menuOpen && (
        <>
          <div 
            className="fixed inset-0 bg-black bg-opacity-50 z-40"
            onClick={() => setMenuOpen(false)}
          />
          <div className="fixed right-0 top-0 bottom-0 w-64 bg-white shadow-lg z-50">
            <div className="flex flex-col h-full">
              <div className="flex justify-between items-center p-4">
                <h2 className="text-xl font-bold">Menú</h2>
                <button 
                  onClick={() => setMenuOpen(false)}
                  className="p-2 hover:bg-gray-100 rounded-full"
                >
                  <X className="w-6 h-6" />
                </button>
              </div>

              {/* Business Switcher */}
              <BusinessSwitcher />

              <nav className="p-4 space-y-4">
                <button 
                  className="w-full text-left px-4 py-2 hover:bg-gray-100 rounded flex items-center gap-2"
                  onClick={() => handleNavigation('/businesses')}
                >
                  <Building2 className="w-5 h-5" />
                  <span>Gestionar Negocios</span>
                </button>
                <button 
                  className="w-full text-left px-4 py-2 hover:bg-gray-100 rounded"
                  onClick={() => handleNavigation('/settings')}
                >
                  Configuración
                </button>
                <button 
                  onClick={() => {
                    handleNavigation('/profile');
                    setMenuOpen(false);
                  }}
                  className="flex items-center space-x-3 p-4 w-full hover:bg-gray-100"
                >
                  <User className="w-6 h-6" />
                  <span>Mi Perfil</span>
                </button>
                <button 
                  onClick={() => {
                    handleNavigation('/subscription');
                    setMenuOpen(false);
                  }}
                  className="flex items-center space-x-3 p-4 w-full hover:bg-gray-100"
                >
                  <CreditCard className="w-6 h-6" />
                  <span>Suscripción</span>
                </button>
                <button 
                  className="w-full text-left px-4 py-2 hover:bg-gray-100 rounded"
                  onClick={() => handleNavigation('/settings/help')}
                >
                  Ayuda
                </button>

                {/* Botón de cerrar sesión */}
                <button 
                  className="w-full text-left px-4 py-2 hover:bg-gray-100 rounded text-red-600"
                  onClick={handleLogout}
                >
                  Cerrar Sesión
                </button>
                
                {/* Separador y sección de desarrollo */}
                <div className="border-t border-gray-200 pt-4">
                  <p className="px-4 text-sm text-gray-500 mb-2">Desarrollo</p>
                  <button 
                    className="w-full text-left px-4 py-2 hover:bg-gray-100 rounded text-blue-600"
                    onClick={() => handleNavigation('/login')}
                  >
                    Ver Login Page
                  </button>
                  <button 
                    className="w-full text-left px-4 py-2 hover:bg-gray-100 rounded flex items-center gap-2"
                    onClick={() => handleNavigation('/create-business-1')}
                  >
                    <Building2 className="w-4 h-4" />
                    Crear Negocio 1
                  </button>
                  <button 
                    className="w-full text-left px-4 py-2 hover:bg-gray-100 rounded flex items-center gap-2"
                    onClick={() => handleNavigation('/create-business-2')}
                  >
                    <Building2 className="w-4 h-4" />
                    Crear Negocio 2
                  </button>
                </div>
              </nav>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default SideMenu; 